<template>
  <div>
    <div class="description">
      <p>
        Every event needs a name. <br />
        The event can be named something like:<br />"Fall Conference"<br />
        Or it can be something more specific like<br />
        "Middle School Fall Conference".
      </p>
      <p><b>Enter your event Name</b><br />You can always change this later.</p>
    </div>
    <div class="name-el">
      <v-text-field
        :disabled="wizard.loading"
        bg-color="white"
        color="primary"
        label="Event Name"
        v-model="wizard.name"
        data-cy="wizard-event-name"
        class="centered-text-field"
      >
      </v-text-field>
    </div>
  </div>
</template>

<script setup lang="ts">
import useWizard from "@/stores/school/wizard";

const wizard = useWizard();
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.name-el {
  margin-top: 20px;
  width: 100%;
  max-width: 100%;

  /* Added flexbox properties */
  display: flex;
  justify-content: center;
  align-items: center;
}
.centered-text-field {
  width: 100%; /* Adjust the width as needed */
}

.description {
  text-align: center;
  font-size: large;
  min-width: min-content;
}
</style>
